import * as React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import CustomTable from '../../../../Components/Table';

function createData(Date, Applicant, Vendor, WorkExperience, Skill, Actions) {
    return {
        Date,
        Applicant,
        Vendor,
        WorkExperience,
        Skill,
        Actions
    };
}

const rows = [
    createData('26/12/2022', 'Applicant 1', 'Vendor 1', '2', 'Skill1, Skill2', 'Accept'),
    createData('27/12/2022', 'Applicant 1', 'Vendor 2', '2', 'Skill2, Skill3', 'Hire Me!'),
    createData('28/12/2022', 'Applicant 1', 'Vendor 3', '2', 'Skill3, Skill2', 'Hire Me!'),
    createData('29/12/2022', 'Applicant 1', 'Vendor 4', '2', 'Skill4, Skill2', 'Hire Me!'),
    createData('30/12/2022', 'Applicant 1', 'Vendor 5', '2', 'Skill4, Skill2', 'Hire Me!'),
    createData('31/12/2022', 'Applicant 1', 'Vendor 6', '2', 'Skill4, Skill2', 'Hire Me!'),
];

const headCells = [
    {
        id: 'Date',
        numeric: false,
        disablePadding: true,
        label: 'Project Date',
    },
    {
        id: 'Applicant',
        numeric: false,
        disablePadding: false,
        label: 'Applicant Name',
    },
    {
        id: 'Vendor',
        numeric: false,
        disablePadding: false,
        label: 'Vendor',
    },
    {
        id: 'WorkExperience',
        numeric: false,
        disablePadding: false,
        label: 'Work Experience',
    },
    {
        id: 'Skill',
        numeric: false,
        disablePadding: false,
        label: 'Skill',
    },
    {
        id: 'Actions',
        numeric: false,
        disablePadding: false,
        label: 'Actions',
    },
];

export default function ListOfApplicants2({ setProjectStatus, project, setProject }) {
    const CustomRow = ({ row }) => {
        return (
            <TableRow
                hover
                role="checkbox"
                tabIndex={-1}
                key={row.Date}
                className='cursor-pointer'
            >
                <TableCell
                    component="th"
                    scope="row"
                    padding="none"
                >
                    {row.Date}
                </TableCell>
                <TableCell align="left">{row.Applicant}</TableCell>
                <TableCell align="left">{row.Vendor}</TableCell>
                <TableCell align="left">{row.WorkExperience}</TableCell>
                <TableCell align="left">{row.Skill}</TableCell>
                <TableCell align="left">
                    <div className='flex justify-between items-center'>
                        <span className='px-2 py-1' style={{
                            border: "1px solid #139588",
                            color: "#139588",
                            borderRadius: "4px"
                        }}>
                            {row.Actions}
                        </span>
                        <span>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 17 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="mr-4"
                            >
                                <path
                                    d="M4.25 10.3194H9.37125C9.61208 10.3194 9.81042 10.2368 9.96625 10.0717C10.1221 9.9072 10.2 9.70311 10.2 9.45945C10.2 9.2158 10.1187 9.01142 9.95605 8.84631C9.79285 8.68177 9.59083 8.5995 9.35 8.5995H4.22875C3.98792 8.5995 3.78958 8.68177 3.63375 8.84631C3.47792 9.01142 3.4 9.2158 3.4 9.45945C3.4 9.70311 3.48132 9.9072 3.64395 10.0717C3.80715 10.2368 4.00917 10.3194 4.25 10.3194ZM4.25 7.73955H12.7712C13.0121 7.73955 13.2104 7.657 13.3663 7.49189C13.5221 7.32735 13.6 7.12326 13.6 6.8796C13.6 6.63595 13.5184 6.43157 13.3552 6.26646C13.1926 6.10192 12.9908 6.01965 12.75 6.01965H4.22875C3.98792 6.01965 3.78958 6.10192 3.63375 6.26646C3.47792 6.43157 3.4 6.63595 3.4 6.8796C3.4 7.12326 3.48132 7.32735 3.64395 7.49189C3.80715 7.657 4.00917 7.73955 4.25 7.73955ZM4.25 5.1597H12.7712C13.0121 5.1597 13.2104 5.07743 13.3663 4.9129C13.5221 4.74779 13.6 4.5434 13.6 4.29975C13.6 4.0561 13.5184 3.85172 13.3552 3.68661C13.1926 3.52207 12.9908 3.4398 12.75 3.4398H4.22875C3.98792 3.4398 3.78958 3.52207 3.63375 3.68661C3.47792 3.85172 3.4 4.0561 3.4 4.29975C3.4 4.5434 3.48132 4.74779 3.64395 4.9129C3.80715 5.07743 4.00917 5.1597 4.25 5.1597ZM0 15.1136V1.7199C0 1.24693 0.1666 0.841891 0.4998 0.504791C0.832433 0.168264 1.2325 0 1.7 0H15.3C15.7675 0 16.1679 0.168264 16.5011 0.504791C16.8337 0.841891 17 1.24693 17 1.7199V12.0393C17 12.5123 16.8337 12.9173 16.5011 13.2544C16.1679 13.5909 15.7675 13.7592 15.3 13.7592H3.4L1.445 15.7371C1.17583 16.0094 0.867567 16.0702 0.5202 15.9194C0.1734 15.7692 0 15.5006 0 15.1136ZM1.7 13.0497L2.69875 12.0393H15.3V1.7199H1.7V13.0497ZM1.7 1.7199V13.0497V1.7199Z"
                                    fill="#139588"
                                />
                            </svg>
                        </span>
                    </div>
                </TableCell>
            </TableRow>
        )
    }

    return (
        <>
            <CustomTable
                title="List Of Applicants"
                headCells={headCells}
                rows={rows}
                CustomRow={CustomRow}
            />
        </>
    );
}
